import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
  Typography,
} from '@one-thd/sui-atomic-components';
import { CreateAProject } from '@thd-olt-component-react/project-forms';
import { extend } from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { triggerAnalytics } from '../../helpers';
import { LANDING_PAGE_UPDATED } from '../project-summary-helper';

const handleExpandCollape = (_event, isExpanded) => {
  if (isExpanded) {
    triggerAnalytics('projects: no projects interaction', {
      event: 'projects: projects page: empty state: faq expand'
    });
  }
};

const EmptyMessagingPro = ({ onProjectCreation }) => {

  useEffect(() => {
    triggerAnalytics('projects.no-projects', {});
  }, []);

  return (
    <div className="sui-flex sui-flex-col sui-gap-8">
      <div className="sui-flex sui-flex-col sui-items-center sui-gap-2">
        <Typography
          variant="h1"
          weight="bold"
          className="sui-text-center sm:sui-text-left"
        >
          Welcome to your New Home for Projects
        </Typography>
        <Typography
          variant="body-lg"
          weight="display"
          className="sui-text-center sm:sui-text-left"
        >
          Plan, Quote and Track your jobs from start to finish all in one place
        </Typography>
        <img
          src={LANDING_PAGE_UPDATED}
          width={1036}
          height={299}
          alt="Welcome to your New Home for Projects"
          title="Welcome to your New Home for Projects"
          // loading="lazy"
        />
        <div className="sui-w-80">
          <CreateAProject onCreate={onProjectCreation} />
        </div>
      </div>
      <Typography variant="h2" weight="display">Frequently Asked Questions</Typography>
      <div className="sui-flex sui-flex-col sui-gap-4">
        <Accordion onChange={handleExpandCollape}>
          <AccordionHeader>How Do I Create a Project?</AccordionHeader>
          <AccordionBody>
            Select Pro Xtra members can create Projects by visiting the Projects page within your Account and
            select &quot;Create New Project&quot;. Once you create a Project, begin adding materials and sharing with
            collaborators to work on the Project together. Your Pro Sales Associate can also start and
            edit a Project for you.
          </AccordionBody>
        </Accordion>
        <Accordion onChange={handleExpandCollape}>
          <AccordionHeader>Who Can View and Edit My Projects?</AccordionHeader>
          <AccordionBody>
            Only users with Purchaser or Admin access can view or edit Projects.
            To share a project with a collaborator who is not a user in your Pro Xtra account, they will only have
            access to view the parts of the project shared with them and leave comments.
          </AccordionBody>
        </Accordion>
        <Accordion onChange={handleExpandCollape}>
          <AccordionHeader>Do Projects Expire?</AccordionHeader>
          <AccordionBody>
            Your Projects never expire and will remain available until you delete them.
            Archive a Project to remove it from your Active Projects list while keeping the Project history.
            Simply set the Project status to &quot;Archived&quot; within your account.
          </AccordionBody>
        </Accordion>
      </div>
    </div>
  );
};

export { EmptyMessagingPro };

EmptyMessagingPro.displayName = 'ProjectSummaryEmptyMessagingPro';

EmptyMessagingPro.propTypes = {
  onProjectCreation: PropTypes.func.isRequired
};

EmptyMessagingPro.defaultProps = {};

EmptyMessagingPro.dataModel = extend(
  CreateAProject
);
